/*
  Dealer application wizard. The same behaviour as Sirair's reseller form:
  one panel at a time, the visible panel validated (native validation
  bubbles) before advancing, and on submit a jump back to the first invalid
  panel. The application is posted as JSON to the dealer app
  (/apps/dealer/apply through the app proxy), which validates it again and
  answers { ok, reference } or { ok: false, error, fields }.
*/
(function () {
  var root = document.querySelector('[data-dealer-apply]');
  if (!root) return;

  var form = root.querySelector('#DealerForm');
  var card = root.querySelector('.da__form-card');
  if (!form || !card) return;

  var success = root.querySelector('[data-da-success]');
  var errorBox = root.querySelector('[data-da-error]');
  var panels = Array.prototype.slice.call(root.querySelectorAll('[data-da-panel]'));
  var stepNow = root.querySelector('[data-da-step-now]');
  var stepLabel = root.querySelector('[data-da-step-label]');
  var segs = Array.prototype.slice.call(root.querySelectorAll('[data-da-seg]'));
  var backBtn = root.querySelector('[data-da-back]');
  var contBtn = root.querySelector('[data-da-continue]');
  var submitBtn = root.querySelector('[data-da-submit]');
  var otherToggle = root.querySelector('[data-da-other-toggle]');
  var otherField = root.querySelector('[data-da-other]');
  var groupFirst = root.querySelector('[data-da-group-first]');
  var endpoint = root.getAttribute('data-endpoint') || '/apps/dealer/apply';
  var contactEmail = root.getAttribute('data-contact-email');
  var portalUrl = root.getAttribute('data-portal-url') || '/pages/my-account';
  var total = panels.length;
  var current = 1;

  function show(n, scroll) {
    current = n;
    panels.forEach(function (p) {
      p.hidden = parseInt(p.getAttribute('data-da-panel'), 10) !== n;
    });
    backBtn.hidden = n === 1;
    contBtn.hidden = n === total;
    submitBtn.hidden = n !== total;
    if (stepNow) stepNow.textContent = n;
    if (stepLabel) stepLabel.textContent = panels[n - 1].getAttribute('data-da-label');
    segs.forEach(function (s, i) {
      s.classList.toggle('is-done', i < n);
    });
    if (scroll) card.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  /* Rules native validation can't express on its own. */
  function applyCustomRules() {
    var phone = form.elements.phone;
    var digits = (phone.value || '').replace(/\D/g, '');
    phone.setCustomValidity(phone.value && digits.length < 9 ? 'Please enter a cell number we can reach you on.' : '');

    var anyType = form.querySelector('input[name="businessTypes"]:checked');
    if (groupFirst) groupFirst.setCustomValidity(anyType ? '' : 'Please choose at least one business type.');

    var other = form.elements.businessTypeOther;
    other.required = Boolean(otherToggle && otherToggle.checked);
  }

  /* The card checkboxes hide their real input behind a drawn box, so the
     browser's validation bubble has nowhere to show: flag the group instead. */
  function reportField(field) {
    if (field.type !== 'checkbox' && field.type !== 'radio') {
      field.reportValidity();
      return;
    }
    var holder = field.closest('.da__group') || field.closest('.da__consent');
    if (!holder) return;
    holder.classList.add('is-invalid');
    var msg = holder.nextElementSibling;
    if (!msg || !msg.classList.contains('da__group-error')) {
      msg = document.createElement('p');
      msg.className = 'da__group-error';
      msg.setAttribute('role', 'alert');
      holder.insertAdjacentElement('afterend', msg);
    }
    msg.textContent = field.validationMessage || 'Please tick this box to continue.';
    holder.scrollIntoView({ behavior: 'smooth', block: 'center' });
    field.focus({ preventScroll: true });
  }

  function clearFlag(field) {
    var holder = field.closest('.da__group') || field.closest('.da__consent');
    if (!holder || !holder.classList.contains('is-invalid')) return;
    holder.classList.remove('is-invalid');
    var msg = holder.nextElementSibling;
    if (msg && msg.classList.contains('da__group-error')) msg.remove();
  }

  function panelValid(n) {
    applyCustomRules();
    var fields = panels[n - 1].querySelectorAll('input, select, textarea');
    for (var i = 0; i < fields.length; i++) {
      if (!fields[i].checkValidity()) {
        reportField(fields[i]);
        return false;
      }
    }
    return true;
  }

  function payload() {
    var data = { businessTypes: [], productsOfInterest: [] };
    new FormData(form).forEach(function (value, key) {
      if (key === 'businessTypes' || key === 'productsOfInterest') data[key].push(value);
      else data[key] = typeof value === 'string' ? value.trim() : value;
    });
    data.consentTerms = form.elements.consentTerms.checked;
    data.consentPopia = form.elements.consentPopia.checked;
    data.marketingOptIn = form.elements.marketingOptIn.checked;
    return data;
  }

  function showError(html) {
    errorBox.querySelector('p').innerHTML = html;
    errorBox.hidden = false;
    errorBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function showSuccess(result) {
    card.hidden = true;
    success.hidden = false;
    success.querySelector('[data-da-success-ref]').textContent = result.reference || '';
    if (result.status === 'updated') {
      success.querySelector('[data-da-success-title]').textContent = 'Application updated';
      success.querySelector('[data-da-success-text]').innerHTML =
        'We already had an application from this email, so we\'ve updated it with these details. Your reference is <strong>' +
        escapeHtml(result.reference || '') + '</strong>.';
    }
    success.scrollIntoView({ behavior: 'smooth', block: 'center' });
    success.focus({ preventScroll: true });
  }

  function sendApplication() {
    var restore = submitBtn.textContent;
    submitBtn.disabled = true;
    submitBtn.textContent = 'Submitting…';
    errorBox.hidden = true;
    form.querySelectorAll('[aria-invalid="true"]').forEach(function (el) {
      el.removeAttribute('aria-invalid');
    });

    fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload())
    })
      .then(function (res) {
        // When the app is unreachable Shopify answers with a theme 404 page, not JSON.
        return res.json().catch(function () { return null; });
      })
      .then(function (result) {
        if (!result) throw new Error('unavailable');
        if (result.ok) return showSuccess(result);

        var firstStep = null;
        Object.keys(result.fields || {}).forEach(function (name) {
          var el = form.querySelector('[name="' + name + '"]');
          if (!el) return;
          el.setAttribute('aria-invalid', 'true');
          var step = parseInt(el.closest('[data-da-panel]').getAttribute('data-da-panel'), 10);
          if (!firstStep || step < firstStep) firstStep = step;
        });
        if (firstStep && firstStep !== current) show(firstStep, true);

        var messages = Object.keys(result.fields || {}).map(function (k) { return escapeHtml(result.fields[k]); });
        var html = escapeHtml(result.error || 'Please check your details and try again.');
        if (messages.length) html += '<br>' + messages.join('<br>');
        if (result.code === 'already_approved') html += ' <a href="' + portalUrl + '">Go to My account</a>';
        showError(html);
      })
      .catch(function () {
        showError(
          'We couldn\'t send your application just now. Please try again in a moment, or email it to <a href="mailto:' +
            contactEmail + '">' + contactEmail + '</a>.'
        );
      })
      .then(function () {
        submitBtn.disabled = false;
        submitBtn.textContent = restore;
      });
  }

  if (otherToggle && otherField) {
    otherToggle.addEventListener('change', function () {
      otherField.hidden = !otherToggle.checked;
      if (otherToggle.checked) form.elements.businessTypeOther.focus();
    });
  }

  // Clear a flagged field as soon as it is edited.
  form.addEventListener('input', function (e) {
    if (e.target.getAttribute && e.target.getAttribute('aria-invalid') === 'true') e.target.removeAttribute('aria-invalid');
  });
  form.addEventListener('change', function (e) {
    if (e.target.type === 'checkbox' || e.target.type === 'radio') {
      applyCustomRules();
      clearFlag(e.target);
    }
  });

  contBtn.addEventListener('click', function () {
    if (panelValid(current) && current < total) show(current + 1, true);
  });

  backBtn.addEventListener('click', function () {
    if (current > 1) show(current - 1, true);
  });

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    applyCustomRules();
    if (form.checkValidity()) {
      sendApplication();
      return;
    }
    for (var n = 1; n <= total; n++) {
      // Fieldsets match :invalid too; report the control itself.
      var invalid = panels[n - 1].querySelector('input:invalid, select:invalid, textarea:invalid');
      if (!invalid) continue;
      if (n !== current) show(n, true);
      setTimeout(function () { reportField(invalid); }, 60);
      break;
    }
  });

  show(1);

  // Design previews (never on the live theme):
  //   ?demo=success  the confirmation after applying
  //   ?demo=dealer   what a signed-in dealer sees on this page
  //   ?hero=N        candidate banner photo assets/dealer-hero-option-N.jpg
  var theme = window.Shopify && window.Shopify.theme;
  var params = theme && theme.role !== 'main' ? new URLSearchParams(window.location.search) : null;
  var demo = params && params.get('demo');
  if (demo === 'success') {
    showSuccess({ ok: true, status: 'received', reference: 'GOR-261009-K7QX' });
  } else if (demo === 'dealer') {
    card.hidden = true;
    root.querySelector('[data-da-already]').hidden = false;
  }

  var hero = params && params.get('hero');
  var heroMedia = root.querySelector('.gor-hero__media');
  if (hero && /^\d+$/.test(hero) && heroMedia && root.dataset.heroOptionBase) {
    var heroImg = heroMedia.querySelector('img');
    heroImg.removeAttribute('srcset');
    heroImg.removeAttribute('sizes');
    heroImg.src = root.dataset.heroOptionBase + 'dealer-hero-option-' + hero + '.jpg';
    heroMedia.classList.remove('gor-hero__media--contain');
  }
})();
